import React, { Component } from "react"

import Header from '../../components/Header/Header';
import Content_TarifasTarjetas from "./Content_TarifasTarjetas";
import Footer from '../../components/Footer/Footer';

class TarifasDeLasTarjetas extends Component {
    render() {
        return (

            <div class="main-container">
                <Header />
                <Content_TarifasTarjetas />
                <Footer />
            </div>

        )
    }
}

export default TarifasDeLasTarjetas;